import React from "react"
import PropTypes from "prop-types"
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class RatingStars extends React.Component {
  constructor(props) {
    super(props)

    this.state = { 
      ...props.config,
    }

    this.config = {
      types : [
        {
          title: 'default',
          isDefault: true,
        },
      ],
      modifiers : [],
      states : []
    }

    this.starsLength = 5; // 5 stars
    let rate = props.rate && props.rate || props.config && props.config.rate,
    intValue = parseInt(rate),
    decimalValue = rate%1 * 10,
    stars = []
    
    if(decimalValue < 3) {
      decimalValue = 0;
    } else if(decimalValue > 3 && decimalValue < 7) {
      decimalValue = 5
    } else {
      decimalValue = 0;
      intValue++;
    }
    
    for(var i = 0; i < intValue; i++) {
      stars[i]={type : "avaliacao"}
    }
    
    if(decimalValue) { 
      stars[i]={type : "meia-avaliacao"}
      i++;
    }

    for(null; i < this.starsLength; i++) {
      stars[i]={type : "avaliacao-vazia"}
    }
    
    this.state = {
      stars : stars
    }

    this.renderStars = this.renderStars.bind(this);
    this.handleStarClick = this.handleStarClick.bind(this);
  }

  renderStars(readOnly) { 
    return this.state.stars.map((star, index) => 
      <span className={"mdn-Icon-"+star.type + " mdn-Icon--sm mdn-RatingStars-star"} key={index} onClick={()=>{this.handleStarClick(index,readOnly)}}/>
    )
  }

  handleStarClick(key,readOnly) {
    key++; // normalize stars array length
    let stars = [];
    if(readOnly) { return }
    for(let i = 0; i < this.starsLength; i++){
      i < key ? stars.push({type : "avaliacao"}) : stars.push({type : "avaliacao-vazia"})
    }
    this.setState({
      stars : stars
    })
  }

  renderRatingStars(currentRate) { 
    currentRate && this.rateReadOnly(currentRate)
  }

  rateReadOnly(index, readOnly) { 
    if(!readOnly) { return }
    let decimalBR = String(index).replace('.' , ',')    
    return <h3 className="mdn-RatingStars-rate mdn-Heading mdn-Heading--sm">{decimalBR}</h3>
  }

  renderTotalRating(readOnly, children) {
    if(!readOnly) { return }
    return <p className="mdn-RatingStars-evaluation mdn-Text mdn-Text--caption ">
      {children}
    </p>
  }

  render() {    
    let { rate, readOnly, children, ...rest } = this.props
    const props = clearProps(this.props)

    return <div {...props} className={resolveProps(this.props, this.config, 'RatingStars')} data-mdn-rate={rate}>
      {this.rateReadOnly(rate, readOnly)}
      <label className="mdn-RatingStars-check">
        {this.renderStars(readOnly)}
      </label>
      {this.renderTotalRating(readOnly, children)}
    </div>
  }
}

RatingStars.propTypes = {
  rate : PropTypes.number,
  readOnly : PropTypes.bool,
  config : PropTypes.object
}